import { useState } from "react";

export const useToken = () => {
    const [token, setTokenInternal] = useState(() => {
        return localStorage.getItem('authToken');
    });

    const setToken = newToken => {
        if (!newToken) {
            localStorage.removeItem('authToken');
            setTokenInternal(null);
        } else {
            localStorage.setItem('authToken', newToken);
            setTokenInternal(newToken);
        }
    }

    return [token, setToken];
}